module.exports = __webpack_public_path__ + "static/media/xk.2750d8e7.svg";